<div class="modal-content modal-milvus modal-aviso-notificacao">
    <div class="modal-header modal-header-aviso">
        <h6 class="modal-title" id="modal-title-default">{{ 'AVISO' | translate }}</h6>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close()">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body modal-body-aviso">
        <div class="conteudo-template-aviso" [innerHTML]="descricaoSanitizada"></div>
    </div>
    <div class="modal-footer modal-footer-aviso">
        <div class="opcao-nao-mostrar-aviso" *ngIf="exibirOpcaoNaoMostrarNovamente">
            <label class="checkbox-nao-mostrar-aviso">
                <input
                    type="checkbox"
                    [(ngModel)]="naoMostrarAvisoNovamenteMarcado"
                />
                <span [translate]="'NAO_MOSTRAR_ESTE_AVISO_NOVAMENTE'"></span>
            </label>
        </div>
        <div class="acoes-aviso" [class.acoes-aviso-sem-checkbox]="!exibirOpcaoNaoMostrarNovamente">
            <button
                type="button"
                class="btn btn-darkblue badge-pill"
                (click)="confirmarEntendi()"
                [disabled]="salvandoOcultacao"
            >
                <span [translate]="'ENTENDI_AVISO'"></span>
            </button>
        </div>
    </div>
</div>
